import React from "react";
import ScrollToTop from "../Component/ScrollToTop";

const ReturnReplacementPolicy = () => {
  return (
    <>
      <ScrollToTop />

      {/* HERO */}
      <section className="bg-light py-5">
        <div className="container text-center">
          <h1 className="fw-bold mb-2">Return & Replacement Policy</h1>
          <p className="text-muted fs-5">
            Your satisfaction is our priority
          </p>
        </div>
      </section>

      {/* CONTENT */}
      <section className="container my-5">
        <div className="row justify-content-center">
          <div className="col-lg-9">
            <div className="card shadow-sm border-0 rounded-4 p-4">

              <h4 className="fw-semibold mb-3">🔁 Return Eligibility</h4>
              <p>
                FreshCart allows returns or replacements only in cases where
                the product delivered is <strong>damaged, expired, incorrect,
                or missing</strong>.
              </p>
              <p>
                Requests must be raised within <strong>24 hours</strong> of
                delivery.
              </p>

              <hr />

              <h4 className="fw-semibold mb-3">📦 Non-Returnable Items</h4>
              <p>
                For hygiene and safety reasons, the following items are not
                eligible for return:
              </p>
              <ul>
                <li>Fresh fruits & vegetables</li>
                <li>Dairy & frozen products</li>
                <li>Opened or used items</li>
                <li>Perishable goods</li>
              </ul>

              <hr />

              <h4 className="fw-semibold mb-3">🔄 Replacement Policy</h4>
              <p>
                If a replacement is approved, the item will be replaced at no
                additional cost. Replacement depends on product availability.
              </p>
              <p>
                If replacement is not possible, a refund will be processed.
              </p>

              <hr />

              <h4 className="fw-semibold mb-3">⏳ Replacement Timeline</h4>
              <ul className="timeline-list">
                <li>
                  <strong>Step 1:</strong> Raise a replacement request within{" "}
                  <strong>24 hours</strong> of delivery along with images or
                  video proof.
                </li>
                <li>
                  <strong>Step 2:</strong> Our team verifies the request within{" "}
                  <strong>24–48 hours</strong>.
                </li>
                <li>
                  <strong>Step 3:</strong> After approval, the replacement is
                  dispatched within <strong>2-3 hours</strong>.
                </li>
                <li>
                  <strong>Step 4:</strong> Replacement product is delivered
                  within <strong>2-3 hours</strong>, depending on your
                  location.
                </li>
              </ul>

              <hr />

              <h4 className="fw-semibold mb-3">💸 Refund Policy</h4>
              <p>
                Approved refunds are processed to the original payment method
                within <strong>5–7 business days</strong>.
              </p>
              <p>
                Cash on Delivery (COD) refunds may be processed via wallet or
                bank transfer.
              </p>

              <hr />

              <h4 className="fw-semibold mb-3">📸 Proof Required</h4>
              <p>
                To process a return or replacement, customers may be asked to
                provide images or videos of the product received.
              </p>

              <hr />

              <h4 className="fw-semibold mb-3">❌ Order Cancellation</h4>
              <p>
                Orders once packed or out for delivery cannot be cancelled.
                FreshCart reserves the right to cancel orders due to
                unavailability or unforeseen issues.
              </p>

              <hr />

              <h4 className="fw-semibold mb-3">📞 Need Help?</h4>
              <p className="mb-0">
                For any return or replacement related queries, contact us at{" "}
                <strong>+91 7856000970</strong> or visit the Contact page.
              </p>

            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ReturnReplacementPolicy;